const galleryHr = {
    "file_upload_successful": "Prijenos datoteke uspješan",
    "file_upload_error": "Pogreška pri učitavanju datoteke",
    "attach_files": "Priloži datoteke",
    "files_selected": "Odabrane datoteke",
    "upload": "Prenesi",
    "uploading": "Prijenos",
    "maximum_file_size": "Maksimalna dopuštena veličina za prijenos je 10 MB.",
    "download": "Preuzmi",
    "open_in_new_tab": "Otvori u novoj kartici",
    "delete_file": "Izbriši datoteku",
    "confirm_delete": "Jeste li sigurni da želite izbrisati ovu datoteku?",
    "image_in_use": "Odabrana slika se koristi u sljedećim aktivnim stavkama izbornika:",
    "image_in_use_tip": "Da biste izbrisali ovu datoteku, uklonite je sa svih aktivnih popisa.",
    "file_deleted_successfully": "Datoteka je uspješno izbrisana",
    "error_deleting_file": "Pogreška pri brisanju datoteke",
    "confirm_selection": "Potvrdi odabir",
    "file_deletion_forbidden": "Brisanje datoteka zabranjeno"
};

export default galleryHr;
